import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { ToggleButtonGroupRoot } from './ToggleButtonGroup.style';

const ToggleButtonGroup = forwardRef(({ children, ...rest }, ref) => {
  return (
    <ToggleButtonGroupRoot ref={ref} {...rest}>
      {children}
    </ToggleButtonGroupRoot>
  );
});

ToggleButtonGroup.propTypes = {
  /**
   * Indicates whether the group is rendered with icons in it
   */
  withIcons: PropTypes.bool,
  /**
   * Indicates if the group consists of icons only
   */
  iconsOnly: PropTypes.bool
};

ToggleButtonGroup.displayName = 'ToggleButtonGroup';

export default ToggleButtonGroup;
